import React, { useEffect, useRef } from "react";
import {
  Col,
  Drawer,
  Form,
  Row,
  Typography,
  Button as AntdButton,
  Upload,
  Space,
  Divider,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  FormInput,
  FormInputArea,
  FormHiddenSubmitButton,
  FormPhoneNumber,
  FormSelect,
  FormCheckbox,
} from "components/FormItems/FlatFormItems";
import { useForm } from "antd/lib/form/Form";
import { Button } from "components/Buttons/Buttons";
import FilesUploader from "components/FilesUploader/FilesUploader";
import { getCategoryById } from "services/categoriesSettings.services";
import { useDispatch } from "react-redux";

const { Title, Text } = Typography;
const { Dragger } = Upload;

const PRICINGS = [1, 2, 3];

export default function SkillsDrawer({ data, visible, onClose, onSuccess }) {
  const [form] = useForm();
  const submitBtnRef = useRef();

  const dispatch = useDispatch();

  // const getData = async (id) => {
  //   const result = await dispatch(getCategoryById(id));
  //   if (result?.status === "success") {
  //     form.setFieldsValue({
  //       ...result.data,
  //     });
  //   }
  // };

  useEffect(() => {
    if (visible === false) {
      form.resetFields();
    } else if (data?.id !== undefined) {
      form.setFieldsValue({
        ...data,
      });
      // getData(data?.categoryId);
    }
  }, [visible]);

  return (
    <Drawer
      destroyOnClose
      headerStyle={{ border: "none" }}
      className="skillsDrawer"
      width={"min(100vw, 420px)"}
      title={
        <div className="skillsDrawerTitle">
          <p>
            {visible && (data?.id !== undefined ? "Edit" : "Create")} Skill
          </p>
          <CloseOutlined onClick={onClose} />
        </div>
      }
      placement="right"
      onClose={onClose}
      visible={visible}
      closable={false}
      footer={
        <div className="skillsDrawerFooter">
          <AntdButton type="text" onClick={onClose}>
            Cancel
          </AntdButton>
          <Button
            rounded
            type={"primary"}
            style={{ height: 50, width: "50%" }}
            onClick={() => submitBtnRef?.current?.click()}
          >
            Save
          </Button>
        </div>
      }
    >
      <Form
        preserve={false}
        layout="vertical"
        form={form}
        requiredMark={false}
        onFinish={(values) => {
          onSuccess(values);
        }}
        onFinishFailed={({ values, errorFields, outOfDate }) => {
          form.scrollToField(errorFields[0].name, {
            scrollMode: "if-needed",
            block: "center",
            behavior: "smooth",
          });
        }}
      >
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <FormInput
              name="name"
              variant="underlined"
              label="Skill Name"
              required
              placeholder="Skill Name"
              formItemStyles={{
                marginBottom: 0,
              }}
            />
          </Col>
          <Col xs={24}>
            <FormInputArea
              placeholder="Skill Description"
              label="Skill Description"
              name={"description"}
              variant="underlined"
              formItemStyles={{ width: "100%", marginBottom: 0 }}
              // initialValue={notes[0] ? notes[0].noteDescription : ''}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <FormHiddenSubmitButton submitRef={submitBtnRef} />
        </Row>
      </Form>
    </Drawer>
  );
}
